<template>
  <div class="share-container">
    <div class="status">
      <img src="@/assets/img/share/order/status_icon.png" alt="">
      <div class="status-text">订单状态：{{detail.statusName}}</div>
    </div>
    <div class="address">
      <img src="@/assets/img/share/order/address_icon.png" alt="">
      <div class="address-info">
        <div class="person">
          <span>{{detail.groupName}}</span>
          <span>{{detail.username}}</span>
        </div>
        <div class="detail">
          {{detail.address}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.share-container {
  .status {
    height: 13vh;
    padding: 2vh 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background-image: url('~@/assets/img/share/order/status_bg.png');
    background-size: cover;
    img {
      width: 7vw;
    }
    &-text {
      color: #fff;
      font-size: 14px;
    }
  }
  .address {
    display: flex;
    height: 14.2vh;
    padding: 2.8vh 5vw;
    background-color: #fff;
    img {
      width: 4vw;
      object-fit: contain;
    }
    &-info {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin-left: 5vw;
      .person {
        font-size: 14px;
        font-weight: 600;
        color: #1d2c36;
      }
      .detail {
        font-size: 12px;
        color: rgba(#1d2c36, 0.5);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/confirm-order/components/OrderHeader.vue